module.exports = __webpack_public_path__ + "img/email-icon2.5618822e.svg";